export function emailValidate(email) {
  if (
    email.includes("@") &&
    email.includes(".") &&
    email.length < 255 &&
    email !== ""
  ) {
    return true;
  }
  return false;
}
export function phoneValidate(phone) {
  return new RegExp(
    /(\+\d{1,3}\s?)?((\(\d{3}\)\s?)|(\d{3})(\s|-?))(\d{3}(\s|-?))(\d{4})(\s?(([E|e]xt[:|.|]?)|x|X)(\s?\d+))?/g
  ).test(phone);
}
